import Config from "./Config";
import {gsap, Expo, Quart, Quad, Sine, Linear} from "gsap";

import Top from "./Top";
import Page404 from "./Page404";
import VoicesSingle from "./VoicesSingle";
import VoicesArchive from "./VoicesArchive";
import Requirements from "./Requirements";
import Entry from "./Entry";
import Faq from "./Faq";
import Culture from "./Culture";
import Message from "./Message";

class BarbaCustom {
    constructor() {
        this.init();
    }

    init(){
        let sc = this;
        this.setVars();
        this.setDom();
        this.initEvents();
        this.initTransition();

        Barba.Pjax.getTransition = function() {
            return sc.transition;
        };

        Barba.Pjax.start();
        Barba.Prefetch.init();
        this.cancelSameLinks();
        // this.preventCheck();
    }

    /*    preventCheck(){
            //TODO この関数内の処理は画面クリックしただけでwindow.historyが追加されていってしまったため、barba.jsに直接追加記述 2020/9/8 by Masayuki Daijima
            let sc = this;
            Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
            Barba.Pjax.preventCheck = function(evt, element) {
                if(element){
                    // アンカーリンクであり同一ページでなければPjaxを有効に
                    let url = location.protocol + '//' + location.host + location.pathname;
                    let extract_hash = element.href.replace(/#.*$/,"");

                    // if (element.href.startsWith(location.protocol + '//' + location.host)) {}
                    if (element.target === "_blank") return false;
                    if (element.href.indexOf('#') > -1 &&  extract_hash != url ) return true;
                    if (element.href.startsWith('mailto:')) return false;
                }
                return true;
            };
        }
    */

    setVars(){
        this.pack = Config.getInstance();
        this.pack.barba = this;
        this.before;
    }

    setDom(){
        this.wrapper = document.querySelector('#barba-wrapper');
        this.barbaContainer = document.querySelector('.barba-container');
        this.transition = document.querySelector('#transition');
        this.scrollWrapper = document.querySelector('.scroll-wrapper');
    }

    initEvents(){
        Barba.Dispatcher.on('newPageReady', this.newPageReadyHandler.bind(this));
        Barba.Dispatcher.on('linkClicked', this.linkClickedHandler.bind(this));
        Barba.Dispatcher.on('initStateChange', this.initStateChangeHandler.bind(this));
        Barba.Dispatcher.on('transitionCompleted', this.transitionCompletedHandler.bind(this));
    }

    scrollToHashTarget(){
        let hash = window.location.hash;
        if(!hash || hash.length <= 1) return false;

        let targetId = '';
        try{
            targetId = decodeURIComponent(hash.replace('#', '')).trim();
        }catch(error){
            targetId = hash.replace('#', '').trim();
        }
        if(!targetId) return false;

        let target = document.getElementById(targetId);
        if(!target) return false;

        let header = document.querySelector('header');
        let offset = header
            ? Math.round(header.getBoundingClientRect().height + 24)
            : (window.innerWidth <= this.pack.BP ? 88 : 120);

        let top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo(0, Math.max(top, 0));
        this.pack.common.resetScrollY();

        return true;
    }

    hasRequirementsLocationTarget(){
        if(this.pack.current !== 'requirements') return false;

        try{
            let searchParams = new URLSearchParams(window.location.search || '');
            return Boolean(searchParams.get('tab') || searchParams.get('requirement') || searchParams.get('requirement_id'));
        }catch(error){
            return false;
        }
    }

    initStateChangeHandler(currentStatus){
        let namespace = this.pack.current;
        let pack = this.pack;

        trace('initStateChange', namespace, Barba.HistoryManager.history.length);

        if ( Barba.HistoryManager.history.length === 1 ) {  // ファーストビュー
            return; // この時に更新は必要ありません
        }

        pack.common.lockScroll = true;
        if(pack.common && pack.common.clearLowerEntryMask){
            pack.common.clearLowerEntryMask();
        }

        if (namespace === 'top') {
            this.pack.top.destruct();
        }else if(namespace === 'voices' && this.pack.voicesArchive){
            this.pack.voicesArchive.destruct();
        }else if(namespace === 'page404'){
            this.pack.page404.destruct();
        }else if(namespace === 'voices-single' && this.pack.voicesSingle){
            this.pack.voicesSingle.destruct();
        }else if(namespace === 'requirements' && this.pack.requirements){
            this.pack.requirements.destruct();
        }else if(namespace === 'entry' && this.pack.entry){
            this.pack.entry.destruct();
        }else if(namespace === 'faq' && this.pack.faq){
            this.pack.faq.destruct();
        }else if(namespace === 'culture'){
            this.pack.culture.destruct();
        }else if(namespace === 'message'){
            this.pack.message.destruct();
        }
    }

    initTransition(){
        let sc = this;
        let pack = this.pack;

        this.transition = Barba.BaseTransition.extend({
            start(){
                this.newContainerLoaded = false;
                this.fadeOutCompleted = false;
                sc.isTransition = true;
                pack.past = pack.current;

                //oldContainerが隠れるトランジション終了後のcallback
                let callback = ()=>{
                    pack.header.closeMenuExternal();
                    this.fadeOutCompleted = true;
                    sc.endContentsOutHandler(pack.past);
                    this.checkReady();
                };

                this.contentsOut();

                gsap.delayedCall(.1, ()=>{
                    pack.common.startTransitionIn(callback);
                });
            },

            contentsOut(){
                // this.startSerial()
                //     .then(this.newContainerLoading)
                //     .then(this.initContainer.bind(this));

                this.newContainerLoading.then(this.initContainer.bind(this));
            },

            startSerial(){
                return new Promise(function(resolve){
                    resolve();
                });
            },

            initContainer(){
                if(!this.newContainer) {
                    //SPで遷移後のnewContainerを認識できずにエラーが出る時があるので.2秒待ってもう1回initContainerを呼ぶ
                    TweenMax.delayedCall(.2, this.initContainer.bind(this));
                    return;
                }

                //リンククリック時にnewContainerが表示される場合の処理
                if(this.newContainer) this.newContainer.style.display = "none";

                this.newContainerLoaded = true;
                this.checkReady();
            },

            checkReady(){
                //newContainerの読み込みが完了し、oldContainerが消え切るトランジション完了したかをチェック
                if(this.newContainerLoaded && this.fadeOutCompleted) {
                    this.contentsIn();
                }
            },

            contentsIn(){
                let namespace = pack.current;
                if(this.newContainer){
                    this.newContainer.style.display = "block";
                    this.newContainer.style.visibility = "visible";
                }
                this.done();

                if(namespace === 'top'){
                    if(pack.top) pack.top.reset();
                    else {
                        pack.top = new Top();
                        pack.top.set();
                    }
                    pack.top.start();
                }else if(namespace === 'voices'){
                    if(pack.voicesArchive) pack.voicesArchive.reset();
                    else pack.voicesArchive = new VoicesArchive();
                    pack.voicesArchive.start();
                }else if(namespace === 'page404'){
                    if(pack.page404) pack.page404.reset();
                    else pack.page404 = new Page404();
                    pack.page404.start();
                }else if(namespace === 'voices-single'){
                    if(pack.voicesSingle) pack.voicesSingle.reset();
                    else pack.voicesSingle = new VoicesSingle();
                    pack.voicesSingle.start();
                }else if(namespace === 'requirements'){
                    if(pack.requirements) pack.requirements.reset();
                    else pack.requirements = new Requirements();
                    pack.requirements.start();
                }else if(namespace === 'entry'){
                    if(pack.entry) pack.entry.reset();
                    else pack.entry = new Entry();
                    pack.entry.start();
                }else if(namespace === 'faq'){
                    if(pack.faq) pack.faq.reset();
                    else pack.faq = new Faq();
                    pack.faq.start();
                }else if(namespace === 'culture'){
                    if(pack.culture) pack.culture.reset();
                    else pack.culture = new Culture();
                    pack.culture.start();
                }else if(namespace === 'message'){
                    if(pack.message) pack.message.reset();
                    else pack.message = new Message();
                    pack.message.start();
                }

                if(namespace === 'top'){
                    pack.footer.setFooter(true);
                }else{
                    pack.footer.setFooter(false);
                }

                // pack.header.resetHeader();
                pack.common.setCurrent();
                pack.common.lockScroll = false;

                this.resetScroll();

                //インラインJS
                this.addInlineJs();

                pack.common.resizeHandler();
                gsap.delayedCall(2, function(){
                    //駄目押しリサイズ
                    pack.common.resizeHandler();
                });

                pack.common.startTransitionOut();
                sc.isTransition = false;
            },

            resetScroll(){
                if(sc.scrollToHashTarget()) return;
                if(sc.hasRequirementsLocationTarget()) return;
                window.scrollTo(0,0);
                pack.common.resetScrollY();
            },

            addInlineJs(){
                let js = this.newContainer.querySelector("script");

                if(js != null){
                    let addJs = document.createElement("script");
                    addJs.innerHTML = js.innerHTML;
                    this.newContainer.appendChild(addJs);
                }
            }
        });
    }

    newPageReadyHandler(currentStatus, oldStatus, barbaContainer, newPageRawHTML){
        trace('newPageReady', currentStatus.namespace);

        this.before = this.pack.current;
        let namespace = this.pack.current = currentStatus.namespace;

        if ( Barba.HistoryManager.history.length === 1 ) {  // ファーストビュー
            return; // この時に更新は必要ありません
        }

        //metaタグの差し替え for News Details
        let head = document.head;
        let newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
        let newPageHead = document.createElement('head');
        newPageHead.innerHTML = newPageRawHead;
        let removeHeadTags = [
            "meta[name='post-id']",
        ].join(',');
        let headTags = head.querySelectorAll(removeHeadTags)
        for(let i = 0; i < headTags.length; i++ ){
            head.removeChild(headTags[i]);
        }
        let newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

        for(let i = 0; i < newHeadTags.length; i++ ){
            head.appendChild(newHeadTags[i]);
        }

        // =============================================
        // Googleアナリティクスへ送信
/*        if (typeof gtag === 'function') {
            gtag('config', window.GA_MEASUREMENT_ID,{
                page_path: window.location.pathname
            });
        }*/
        // =============================================
    }

    linkClickedHandler(urrentStatus, event){
        // trace('linkClicked');
    }

    endContentsOutHandler(namespace){
        trace('endContentsOutHandler');

        if (namespace === 'top') {
            this.pack.top.destructAfterContentsOut();
        }
    }

    transitionCompletedHandler(currentStatus, oldStatus, barbaContainer, newPageRawHTML){
        trace('transitionCompleted');
        if(this.scrollToHashTarget()) return;
        if(this.hasRequirementsLocationTarget()) return;
        window.scrollTo(0,0);
        this.pack.common.resetScrollY();
    }

    cancelSameLinks(){
        // 現在と同じページのリンクをクリックした場合、リロードなし。
        let links = document.querySelectorAll('a[href]');
        let cbk = function(event) {
            if(event.currentTarget.href === window.location.href) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        for(let i = 0, len = links.length; i < len; i++) {
            links[i].addEventListener('click', cbk);
        }
    }
}

new BarbaCustom();
